const APIKey = "730a82a8"
export default  APIKey;
